import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins';
import './plugins/filter';
import './plugins/directive';
import VueAnalytics from 'vue-analytics';

import './styles/app.styl';

const isProd = import.meta.env.PROD;

Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm, info) {
  function component(vm, path = []) {
    if (!vm) return path.join('/');
    path.unshift(vm.$options._componentTag);
    return component(vm.$parent, path);
  }

  Object.assign(err, {
    handler: info,
    route: vm.$route.fullPath,
    component: component(vm),
  });

  if (err.name === 'AxiosError') {
    err.method = err.config.method;
    err.baseURL = err.config.baseURL;
    err.url = err.config.url;
    err.params = err.config.params;

    delete err.config;
    delete err.request;
    delete err.response;
  }

  console.error(err);
};

Vue.use(VueAnalytics, {
  id: 'UA-64823840-2',
  router,
  autoTracking: {
    exception: true,
    exceptionLogs: false,
  },
  debug: {
    enabled: false,
    sendHitTask: isProd,
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// Reload page when new deployment
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});
